"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.find-index");

var _toConsumableArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.number.constructor");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuePropertyDecorator = require("vue-property-decorator");

var _elementUi = require("element-ui");

var _loading = require("@/mixins/loading/loading");

var _lastMileDeliveryPricerite = require("@/mixins/last-mile-delivery-pricerite/last-mile-delivery-pricerite");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var defaultRouteForm = {
  locked: false,
  startTime: null,
  convertedStartTime: null,
  waitingTime: null,
  handlingTime: null
};

var LMDTruckSummaryModalComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(LMDTruckSummaryModalComponent, _Mixins);

  var _super = _createSuper(LMDTruckSummaryModalComponent);

  function LMDTruckSummaryModalComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, LMDTruckSummaryModalComponent);
    _this = _super.apply(this, arguments);
    _this.routeForm = _this.helper.cloneDeep(defaultRouteForm);
    _this.visibility = false;
    _this.deletedOrders = [];
    return _this;
  }

  (0, _createClass2.default)(LMDTruckSummaryModalComponent, [{
    key: "onDetailsChanges",
    value: function onDetailsChanges(newVal, oldVal) {
      if (newVal) {
        this.deletedOrders = [];
        this.routeForm = {
          locked: newVal['locked'],
          startTime: newVal['startTime'],
          convertedStartTime: this.helper.convertTimezone(newVal['startTime'], this.$timezone, 'YYYY-MM-DD HH:mm:ss'),
          waitingTime: newVal['waitingTime'] / 60,
          handlingTime: newVal['handlingTime'] / 60
        };
      }
    }
  }, {
    key: "onVisibilityChanges",
    value: function onVisibilityChanges(newVal) {
      this.visibility = newVal;
    }
  }, {
    key: "mounted",
    value: function mounted() {}
  }, {
    key: "onDialogClose",
    value: function onDialogClose() {
      this.$emit('onDialogClose');
    }
  }, {
    key: "updateDetails",
    value: function updateDetails() {
      if (this.checkFormValidation(this.routeForm)) {
        // convert Date to String
        if (this.routeForm['convertedStartTime'] instanceof Date) {
          var dateObj = this.routeForm['convertedStartTime'];
          this.routeForm['convertedStartTime'] = dateObj.getFullYear() + '-' + this.helper.pad(dateObj.getMonth() + 1) + '-' + this.helper.pad(dateObj.getDate()) + ' ' + this.helper.pad(dateObj.getHours()) + ':' + this.helper.pad(dateObj.getMinutes()) + ':00';
        }

        var waitingTime = Number(this.routeForm['waitingTime']) * 60;
        var handlingTime = Number(this.routeForm['handlingTime']) * 60;
        this.$emit('onUpdateRouteDetails', {
          index: this.routeIndex,
          routeForm: {
            locked: this.routeForm['locked'],
            startTime: this.routeForm['startTime'],
            convertedStartTime: this.helper.revertTimezone(this.routeForm['convertedStartTime'], this.$timezone, 'YYYY-MM-DD HH:mm:00'),
            waitingTime: waitingTime,
            handlingTime: handlingTime,
            processingTime: waitingTime + handlingTime
          }
        });
        this.onDialogClose();
      } else {
        var message = {
          title: this.$i18n.t('planning.messages.invalidUpdateRouteDetails'),
          duration: 5000
        };

        _elementUi.Notification.error(message);
      }
    }
  }, {
    key: "checkFormValidation",
    value: function checkFormValidation(form) {
      return !this.helper.isUndefined(form['startTime']) && !this.helper.isUndefined(form['convertedStartTime']);
    }
  }, {
    key: "getOrderId",
    value: function getOrderId(index) {
      return this.routeDetails['waypointId'][index].split('-')[0];
    }
  }, {
    key: "getWaypointEndTime",
    value: function getWaypointEndTime(index) {
      var _this2 = this;

      var waypoints = this.getOrderField(this.getOrderId(index), 'waypoints');

      if (this.helper.isUndefined(waypoints)) {
        return '';
      }

      var waypoint = waypoints.find(function (wp) {
        return wp.id === _this2.routeDetails['waypointId'];
      });

      if (this.helper.isUndefined(waypoint)) {
        return '';
      }

      return waypoint['endTime'];
    }
  }, {
    key: "removeOrders",
    value: function () {
      var _removeOrders = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this3 = this;

        var selectedShipRefs, payload, assignedOrderShipRefs, filteredTrucks, cancelDriverAssignmentPayload, m, cancelDriverAssignmentRes, res, data, message, removeVehicleObj, removedTruckIds, bufferPlan, selectedOrders, dOrders, dOrderIds;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.helper.isUndefined(this.$selectedTruck) || this.deletedOrders.length === 0)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                selectedShipRefs = this.$plan.orders.filter(function (order) {
                  return _this3.deletedOrders.includes(order.id);
                }).map(function (order) {
                  return order.shipmentReference;
                });
                payload = {
                  code: this.$planDate,
                  vehicle: []
                };
                assignedOrderShipRefs = [];
                filteredTrucks = this.$plan.trucks.filter(function (truck) {
                  return truck.truckId === _this3.$selectedTruck;
                });
                filteredTrucks.forEach(function (truck) {
                  var bool = _this3.helper.some(truck.routes, function (r) {
                    var intersect = _this3.helper.intersection(r.shipmentReference, selectedShipRefs);

                    return intersect.length > 0;
                  });

                  if (bool) {
                    var truckShipRefs = _this3.helper.uniq(_this3.helper.flatten(truck.routes.map(function (r) {
                      return r.shipmentReference;
                    })));

                    var deletedShipRef = _this3.helper.intersection(truckShipRefs, selectedShipRefs);

                    var deletedOrders = _this3.$plan.orders.filter(function (o) {
                      return deletedShipRef.includes(o.shipmentReference);
                    });

                    var deletedOrderIds = deletedOrders.map(function (o) {
                      return o.id;
                    });

                    var truckAssignedShipRefs = _this3.helper.uniq(_this3.helper.flatten(truck.routes.filter(function (r) {
                      return r.status.toUpperCase() === 'ASSIGNED';
                    }).map(function (r) {
                      return r.shipmentReference;
                    })));

                    var deletedAssignedShipRef = _this3.helper.intersection(truckAssignedShipRefs, selectedShipRefs);

                    payload.vehicle.push({
                      truckId: truck.truckId,
                      vehicleId: truck.truckId,
                      orderId: deletedOrderIds
                    });
                    assignedOrderShipRefs = [].concat((0, _toConsumableArray2.default)(assignedOrderShipRefs), (0, _toConsumableArray2.default)(deletedAssignedShipRef));
                  }
                }); // Unassign order(s) from driver

                if (!(assignedOrderShipRefs.length > 0)) {
                  _context.next = 22;
                  break;
                }

                cancelDriverAssignmentPayload = [];
                this.helper.forEach(assignedOrderShipRefs, function (order) {
                  cancelDriverAssignmentPayload.push({
                    shipref: order
                  });
                });
                m = {
                  title: this.$i18n.t('planning.messages.unassignFailed'),
                  duration: 5000
                };

                if (!(cancelDriverAssignmentPayload.length === 0)) {
                  _context.next = 15;
                  break;
                }

                m['title'] = this.$i18n.t('planning.messages.noOrdersToUnassign');

                _elementUi.Notification.warning(m);

                return _context.abrupt("return");

              case 15:
                _context.next = 17;
                return this.cancelDriverAssignment(cancelDriverAssignmentPayload);

              case 17:
                cancelDriverAssignmentRes = _context.sent;

                if (cancelDriverAssignmentRes) {
                  _context.next = 21;
                  break;
                }

                _elementUi.Notification.warning(m);

                return _context.abrupt("return");

              case 21:
                this.logger.info('Unassign orders from multiple trucks payload', payload);

              case 22:
                _context.next = 24;
                return this.lastMileDeliveryAPI.removeOrder(payload);

              case 24:
                res = _context.sent;
                data = this.helper.get(res, 'data', null);
                message = {
                  title: this.$i18n.t('planning.messages.removeOrderSuccess'),
                  duration: 5000
                };

                if (data) {
                  _context.next = 31;
                  break;
                }

                message['title'] = this.$i18n.t('planning.messages.removeOrderFailed');

                _elementUi.Notification.error(message);

                return _context.abrupt("return", false);

              case 31:
                removeVehicleObj = data.invalid.find(function (i) {
                  return i.type === 'removevehicle';
                });
                removedTruckIds = this.helper.get(removeVehicleObj, 'vehicleId', []);
                this.$removedTruckIds = (0, _toConsumableArray2.default)(removedTruckIds);
                bufferPlan = this.helper.cloneDeep(this.$plan);
                selectedOrders = bufferPlan['orders'].filter(function (o) {
                  return !selectedShipRefs.includes(o.shipmentReference);
                });
                dOrders = bufferPlan['orders'].filter(function (o) {
                  return selectedShipRefs.includes(o.shipmentReference);
                });
                dOrderIds = dOrders.map(function (o) {
                  return o.id;
                });
                bufferPlan['orders'] = selectedOrders;
                bufferPlan['orderId'] = bufferPlan['orders'].map(function (i) {
                  return i.id;
                });
                data['vehicles'].forEach(function (i) {
                  var truckIndex = bufferPlan['trucks'].findIndex(function (t) {
                    return t.truckId === i.truckId;
                  });

                  if (truckIndex !== -1) {
                    bufferPlan['trucks'][truckIndex] = i;
                  }
                });

                if (this.$removedTruckIds.length > 0) {
                  bufferPlan['trucks'] = bufferPlan['trucks'].filter(function (i) {
                    return !_this3.$removedTruckIds.includes(i.truckId);
                  });
                }

                bufferPlan['truckId'] = bufferPlan['trucks'].map(function (i) {
                  return i.truckId;
                });
                bufferPlan['planId'] = this.helper.flatten(bufferPlan['trucks'].map(function (i) {
                  return i.planId;
                }));
                this.$includedOrders = [].concat((0, _toConsumableArray2.default)(this.$includedOrders), (0, _toConsumableArray2.default)(dOrderIds));
                _context.next = 47;
                return this.$getUnassignedOrders();

              case 47:
                this.$anyChanges = true;

                _elementUi.Notification.success(message);

                this.$setPlan({
                  'plan': bufferPlan
                });
                this.resetData(); // if (assignedOrderShipRefs.length > 0) {

                _context.next = 53;
                return this.savePlan(this.$plan);

              case 53:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function removeOrders() {
        return _removeOrders.apply(this, arguments);
      }

      return removeOrders;
    }()
  }, {
    key: "resetData",
    value: function resetData() {
      this.deletedOrders = [];
      this.$emit('onUpdateModalVisibility', false);
      this.$emit('onResetPlanId');
    }
  }]);
  return LMDTruckSummaryModalComponent;
}((0, _vuePropertyDecorator.Mixins)(_lastMileDeliveryPricerite.LastMileDeliveryMixin, _loading.LoadingMixin));

(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: false
})], LMDTruckSummaryModalComponent.prototype, "isVisible", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], LMDTruckSummaryModalComponent.prototype, "startTime", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Object,
  default: function _default() {}
})], LMDTruckSummaryModalComponent.prototype, "routeDetails", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Number,
  default: null
})], LMDTruckSummaryModalComponent.prototype, "routeIndex", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('routeDetails')], LMDTruckSummaryModalComponent.prototype, "onDetailsChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('isVisible', {
  immediate: true
})], LMDTruckSummaryModalComponent.prototype, "onVisibilityChanges", null);
LMDTruckSummaryModalComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LMDTruckSummaryModalComponent',
  components: {
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-button': _elementUi.Button,
    'el-form': _elementUi.Form,
    'el-form-item': _elementUi.FormItem,
    'el-dialog': _elementUi.Dialog,
    'el-input-number': _elementUi.InputNumber,
    'el-time-picker': _elementUi.TimePicker,
    'el-tooltip': _elementUi.Tooltip,
    'el-select': _elementUi.Select,
    'el-option': _elementUi.Option,
    'el-checkbox': _elementUi.Checkbox,
    'el-date-picker': _elementUi.DatePicker
  }
})], LMDTruckSummaryModalComponent);
var _default2 = LMDTruckSummaryModalComponent;
exports.default = _default2;